import React, { Fragment, useState, useContext, useCallback } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import debounce from "lodash.debounce";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import {
  AttachMoneyOutlined,
  PermIdentityOutlined,
  Link,
  CalendarMonthOutlined,
  MailOutline,
  OpenInNewOutlined,
  KeyboardArrowUpOutlined,
  KeyboardArrowDownOutlined,
} from "@mui/icons-material";
import axios from "axios";
import {
  Box,
  Backdrop,
  CircularProgress,
  Grid,
  Slide,
  Snackbar,
  Alert,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  Dialog,
  DialogActions,
  DialogContent,
  FormHelperText,
  Popover,
  Button,
} from "@mui/material";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // estilos base
import "react-date-range/dist/theme/default.css"; // tema por defecto
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import { NumericFormat } from "react-number-format";
import { CopyToClipboard } from "react-copy-to-clipboard";

import successImg from "assets/img/success.gif";

import {
  cardBodyStyle,
  blackColor,
  ButtonExit,
  ButtonStyle0,
  ButtonTableGrid2,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewLinkPaymentsAdmin(props) {
  const classes = useStyles();

  const [showAdvanced, setShowAdvanced] = useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = useState(false);
  const [radioIva, SetRadioIva] = useState("0");
  const [radioDocument, setRadioDocument] = React.useState("CI");
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });
  const [openSnackbar, setOpenSnackbar] = React.useState({
    mensage: "",
    open: false,
  });
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [anchorElStart, setAnchorElStart] = useState(null);
  const [anchorElEnd, setAnchorElEnd] = useState(null);

  const { urlServices, UserAuth, urlWeb } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  // Expresión regular para validar el formato de correo
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const [values, setValues] = useState({
    nameClient: "",
    lastNameClient: "",
    emailClient: "",
    documentIdClient: "",
    phoneClient: "",
    subtotal: "",
    ivaSubtotal: 0.0,
    total: 0.0,
    startLink: "",
    endLink: "",
    slugFinal: "",
    otherIva: "",
    description: "",
    errorNameClient: false,
    errorLastNameClient: false,
    errorDocumentIdClient: false,
    errorEmailClient: false,
    errorPhoneClient: false,
    errorSubtotal: false,
    errorDescription: false,
  });

  const handleChangeSubtotal = (value) => {
    const numericValue = parseFloat(value) || 0; // value ya viene con punto decimal
    const subtotal = numericValue.toFixed(2);
    const applyIva = radioIva !== "3";
    const ivaRate =
      radioIva === "0"
        ? parseFloat(UserAuth.iva)
        : radioIva === "1"
          ? parseFloat(UserAuth.ivaHoliday)
          : radioIva === "2"
            ? values.otherIva
              ? parseFloat(values.otherIva)
              : 0
            : 0;

    const ivaSubtotalValue = applyIva ? (numericValue * ivaRate) / 100 : 0;

    setValues((prevValues) => ({
      ...prevValues,
      subtotal: subtotal,
      ivaSubtotal: ivaSubtotalValue.toFixed(2),
      total: (numericValue + ivaSubtotalValue).toFixed(2),
    }));
  };

  // Genera número de 6 dígitos (100000 - 999999)
  const generate6DigitNumber = () => {
    return Math.floor(Math.random() * 900000) + 100000;
  };

  // Genera número de 20 dígitos (10000000000000000000 - 99999999999999999999)
  const generate20DigitNumber = () => {
    // Para números muy grandes, usamos strings para evitar problemas con el tipo Number
    let result = "";
    // Primer dígito (1-9) para asegurar 20 dígitos
    result += Math.floor(Math.random() * 9) + 1;
    // Los 19 dígitos restantes (0-9)
    for (let i = 0; i < 19; i++) {
      result += Math.floor(Math.random() * 10);
    }
    return result;
  };

  const submitForm = async () => {
    setLoading(true);
    setError(false);
    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));

    // Validación de campos
    if (!values.nameClient) {
      setValues((prevValues) => ({
        ...prevValues,
        errorNameClient: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo NOMBRE es requerido",
      });
      setLoading(false);
      return;
    }

    if (radioDocument !== "RUC" && !values.lastNameClient) {
      setValues((prevValues) => ({
        ...prevValues,
        errorLastNameClient: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo APELLIDOS es requerido",
      });
      setLoading(false);
      return;
    }

    /* if (!values.documentIdClient) {
      setValues((prevValues) => ({
        ...prevValues,
        errorDocumentIdClient: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo DOCUMENTOS es requerido",
      });
      setLoading(false);
      return;
    }*/

    if (!emailRegex.test(values.emailClient)) {
      setValues({ ...values, errorEmailClient: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: `Debe ingresar un correo electrónico válido`,
      });

      setLoading(false);
      return; // Salir si hay un error
    }

    if (!values.emailClient) {
      setValues((prevValues) => ({
        ...prevValues,
        errorEmailClient: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo CORREO ELECTRÓNICO es requerido",
      });
      setLoading(false);
      return;
    }

    /*  if (!values.phoneClient) {
      setValues((prevValues) => ({
        ...prevValues,
        errorPhoneClient: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo TELÉFONO es requerido",
      });
      setLoading(false);
      return;
    }*/

    if (!values.description) {
      setValues((prevValues) => ({
        ...prevValues,
        errorDescription: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo DESCRIPCIÓN es requerido",
      });
      setLoading(false);
      return;
    }

    if (!dateStart) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha de caducidad de INICIO",
      });
      setLoading(false);
      return;
    }

    if (!dateEnd) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar una fecha de caducidad de FIN",
      });
      setLoading(false);
      return;
    }

    if (!values.subtotal) {
      setValues((prevValues) => ({
        ...prevValues,
        errorSubtotal: true,
      }));
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo SUBTOTAL es requerido",
      });
      setLoading(false);
      return;
    }

    const generate20Digit = generate20DigitNumber();

    setValues((prevValues) => ({
      ...prevValues,
      slugFinal: generate20Digit,
    }));

    try {
      const dataValue = {
        clientsId: UserAuth.clients_id,
        reference: generate6DigitNumber(),
        name: values.nameClient,
        lastName: values.lastNameClient,
        typeDocument: radioDocument || "CI",
        documentId: values.documentIdClient || "123",
        email: values.emailClient,
        phone: values.phoneClient || "123",
        description: values.description,
        iva:
          radioIva === "0"
            ? parseFloat(UserAuth.iva)
            : radioIva === "1"
              ? parseFloat(UserAuth.ivaHoliday)
              : radioIva === "2"
                ? values.otherIva
                  ? parseFloat(values.otherIva)
                  : 0
                : 0,
        subTotal: values.subtotal,
        ivaSubtotal: values.ivaSubtotal,
        total: values.total,
        slug: generate20Digit,
        startExpiration: values.startLink,
        endExpiration: values.endLink,
      };

      const { status } = await axios.post(
        `${urlServices}payment-link`,
        dataValue,
        {
          headers: {
            Authorization: `Bearer ${keyAuthorization}`,
          },
        },
      );

      if (status === 201) {
        setTimeout(() => {
          setLoading(false);
          setOpenSuccess(true);
        }, 1000);

        props.callBackRefresh();

        setValues((prevValues) => ({
          ...prevValues,
          subject: "",
          typeRequest: "",
          typeRequestData: "",
          detailsRequest: "",
          otherIva: "",
          description: "",
        }));
      }
    } catch (error) {
      handleErrorResponse(error);
      setLoading(false);
    }
  };

  const handleErrorResponse = (e) => {
    if (e.response.status === 401) {
      setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
      setError(true);
      setTimeout(() => {
        localStorage.clear();
        setReturnLogin(true);
      }, 4000);
    } else if (e.response.status === 500) {
      setMensageSystem("Error en la consulta con sel servidor.");
      setError(true);
    }
  };

  const handleChange = useCallback((prop, value) => {
    setValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [prop]: value, // Siempre actualiza el valor del campo que cambió
      };

      // Solo aplica estas condiciones si el prop es "otherIva"
      if (prop === "otherIva") {
        newValues.ivaSubtotal = 0.0;
        newValues.subtotal = "";
        newValues.total = 0.0;
      }

      return newValues;
    });

    // Solo usar debounce para realizar validaciones u otros efectos secundarios
    debounceValidation(prop, value);
  }, []);

  const debounceValidation = useCallback(
    debounce((prop, value) => {
      setValues((prevValues) => ({
        ...prevValues,
        errorNameClient: false,
        errorLastNameClient: false,
        errorDocumentIdClient: false,
        errorEmailClient: false,
        errorPhoneClient: false,
        errorSubtotal: false,
        errorDescription: false,
      }));

      setAlert((prevAlert) => ({
        ...prevAlert,
        openAlert: false,
      }));
    }, 10),
    [],
  );

  const handleRadioDocument = (event) => {
    setValues({ ...values, documentIdClient: "" });
    setRadioDocument(event.target.value);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar({ open: false });
  };

  const handleCloseDialogSuccess = () => () => {
    props.exit();
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleRadioIva = (event) => {
    const selectedValue = event.target.value;
    const subtotal = parseFloat(values.subtotal) || 0;
    const ivaRate =
      selectedValue === "0"
        ? parseFloat(UserAuth.iva)
        : selectedValue === "1"
          ? parseFloat(UserAuth.ivaHoliday)
          : selectedValue === "2"
            ? values.otherIva
              ? parseFloat(values.otherIva)
              : 0
            : 0;

    SetRadioIva(selectedValue);

    // Calcular el IVA
    const ivaSubtotalValue =
      selectedValue === "3" ? 0 : subtotal * (ivaRate / 100);

    // Calcular el total
    const total =
      selectedValue === "3" ? subtotal : subtotal + ivaSubtotalValue;

    setValues((prevValues) => ({
      ...prevValues,
      ivaSubtotal: ivaSubtotalValue.toFixed(2),
      total: total.toFixed(2),
    }));
  };

  const handleCopy = () => {
    setOpenSnackbar({ mensage: "Link copiado al portapapeles!", open: true });
  };

  // Manejar apertura del calendario de inicio
  const handleOpenStartCalendar = (event) => {
    setAnchorElStart(event.currentTarget);
  };

  // Manejar cierre del calendario de inicio
  const handleCloseStartCalendar = () => {
    setAnchorElStart(null);
  };

  // Manejar apertura del calendario de fin
  const handleOpenEndCalendar = (event) => {
    setAnchorElEnd(event.currentTarget);
  };

  // Manejar cierre del calendario de fin
  const handleCloseEndCalendar = () => {
    setAnchorElEnd(null);
  };

  // Manejar cambio de fecha inicial
  const handleDateStartChange = (date) => {
    setDateStart(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    // Resetear fecha final si es anterior a la nueva fecha inicial
    if (dateEnd && dateEnd <= date) {
      setDateEnd(null);
      setValues((prev) => ({ ...prev, endLink: "" }));
    }

    setValues((prev) => ({
      ...prev,
      startLink: formattedDate,
    }));

    setAlert({
      ...alert,
      openAlert: false,
    });

    handleCloseStartCalendar();
  };

  // Manejar cambio de fecha final
  const handleDateEndChange = (date) => {
    setDateEnd(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    setValues((prev) => ({
      ...prev,
      endLink: formattedDate,
    }));

    setAlert({
      ...alert,
      openAlert: false,
    });

    handleCloseEndCalendar();
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  const maxLength = 600;

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid
            container
            spacing={2}
            className={classes.containerProfile}
            sx={{ mb: 3 }}
          >
            <Grid item xs={12} sm={12}>
              {error && <Alert severity="error">{mensageSystem}</Alert>}
              <div className={classes.titleCardFilter}>Nuevo link de pago</div>
              <div className={classes.lineBottom}></div>
              <br></br>
            </Grid>
            <Grid item xs={12} sm={12}>
              <PermIdentityOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 30 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 18,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Datos del cliente
              </span>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ color: blackColor }}
              >
                Nombre:{" "}
                <span style={{ fontSize: 10, color: "red" }}>(Requerido)</span>
              </FormLabel>
              <TextField
                name="nameClient"
                value={values.nameClient}
                error={values.errorNameClient}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  let filteredValue;

                  if (radioDocument === "RUC") {
                    // Permitir letras, números y espacios (pero no caracteres especiales)
                    filteredValue = inputValue.replace(
                      /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g,
                      "",
                    );
                  } else {
                    // Validación original: solo letras, tildes, ñ y espacios
                    filteredValue = inputValue.replace(
                      /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                      "",
                    );
                  }
                  handleChange("nameClient", filteredValue);
                }}
                fullWidth
                required
                // label="Nombre"
                margin="dense"
                autoComplete="off"
                size="small"
                placeholder="Ingresar..."
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: radioDocument === "RUC" ? "none" : "block" }}
            >
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ color: blackColor }}
              >
                Apellido:{" "}
                <span style={{ fontSize: 10, color: "red" }}>(Requerido)</span>
              </FormLabel>
              <TextField
                name="lastNameClient"
                value={values.lastNameClient}
                error={values.errorLastNameClient}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  // Permitir solo letras, espacios, ñ y tildes
                  const filteredValue = inputValue.replace(
                    /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                    "",
                  );
                  handleChange("lastNameClient", filteredValue);
                }}
                fullWidth
                required
                // label="Apellidos"
                margin="dense"
                autoComplete="off"
                size="small"
                placeholder="Ingresar..."
              />
            </Grid>
            <Grid item xs={12} sm={7}>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ color: blackColor }}
              >
                Correo electrónico:{" "}
                <span style={{ fontSize: 10, color: "red" }}>(Requerido)</span>
              </FormLabel>
              <TextField
                name="emailClient"
                value={values.emailClient}
                error={values.errorEmailClient}
                onChange={(event) =>
                  handleChange("emailClient", event.target.value)
                }
                fullWidth
                required
                // label="Correo electrónico"
                margin="dense"
                autoComplete="off"
                size="small"
                InputProps={{
                  endAdornment: (
                    <MailOutline
                      fontSize="small"
                      className={classes.iconInput}
                      position="end"
                    ></MailOutline>
                  ),
                }}
                placeholder="Ingresar..."
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={5}
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="text"
                onClick={() => setShowAdvanced(!showAdvanced)}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  mt: { xs: 0, sm: 3 },
                  fontSize: 14,
                }}
              >
                {showAdvanced ? (
                  <>
                    Ocultar opciones <KeyboardArrowUpOutlined />
                  </>
                ) : (
                  <>
                    Mostrar más opciones <KeyboardArrowDownOutlined />
                  </>
                )}
              </Button>
            </Grid>
            {showAdvanced && (
              <>
                <Grid item xs={12} sm={12}>
                  <FormControl>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ color: blackColor }}
                    >
                      Tipo de documento:
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={radioDocument}
                      onChange={handleRadioDocument}
                    >
                      <FormControlLabel
                        value="CI"
                        control={<Radio />}
                        label="Cédula / ID"
                        sx={{ color: blackColor }}
                      />
                      <FormControlLabel
                        value="RUC"
                        control={<Radio />}
                        label="RUC"
                        sx={{ color: blackColor }}
                      />
                      <FormControlLabel
                        value="PPN"
                        control={<Radio />}
                        label="Pasaporte"
                        sx={{ color: blackColor }}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{ color: blackColor }}
                  >
                    Documento:
                  </FormLabel>
                  <TextField
                    name="documentIdClient"
                    value={values.documentIdClient}
                    error={values.errorDocumentIdClient}
                    onChange={(event) => {
                      let newValue = event.target.value;

                      // Si el tipo es número, limitamos la cantidad de dígitos
                      if (radioDocument === "CI") {
                        newValue = newValue.replace(/[^0-9]/g, "").slice(0, 10);
                      } else if (radioDocument === "RUC") {
                        newValue = newValue.replace(/[^0-9]/g, "").slice(0, 13);
                      } else {
                        newValue = newValue.slice(0, 13);
                      }

                      handleChange("documentIdClient", newValue);
                    }}
                    fullWidth
                    label={
                      radioDocument === "CI"
                        ? "Nro. de cédula / ID"
                        : radioDocument === "RUC"
                          ? "Nro. de RUC"
                          : "Nro. de pasaporte"
                    }
                    margin="dense"
                    variant="outlined"
                    autoComplete="off"
                    type="text"
                    size="small"
                    sx={{ mt: 1 }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    sx={{ color: blackColor }}
                  >
                    Teléfono:
                  </FormLabel>
                  <TextField
                    id="outlined-basic"
                    // label="Teléfono móvil"
                    variant="outlined"
                    onChange={(e) => {
                      const value = e.target.value;

                      // Validar que solo contenga números o el signo + al inicio
                      if (value === "" || /^\+?\d*$/.test(value)) {
                        // Además, verificar que no comience con 0 (excepto si es +0)
                        if (
                          value === "" ||
                          (value.length > 0 &&
                            (value[0] === "+" || value[0] !== "0"))
                        ) {
                          handleChange("phoneClient", value);
                        }
                      }
                    }}
                    inputProps={{
                      style: {
                        textAlign: "left",
                      },
                      maxLength: 13,
                    }}
                    value={values.phoneClient}
                    autoComplete="off"
                    margin="dense"
                    size="small"
                    error={values.errorPhoneClient}
                    fullWidth
                    placeholder="+593958732826"
                    helperText="Agregar el prefijo del país EJ: +593"
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={12}>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ color: blackColor }}
              >
                Descripción (Razón del cobro):{" "}
                <span style={{ fontSize: 10, color: "red" }}>(Requerido)</span>
              </FormLabel>
              <TextField
                name="description"
                // label="Descripción (Razón del cobro)"
                value={values.description}
                onChange={(event) =>
                  handleChange("description", event.target.value)
                }
                error={values.errorDescription}
                fullWidth
                margin="dense"
                variant="outlined"
                autoComplete="off"
                placeholder="Ingresar..."
                size="small"
                required
                type="text"
                multiline
                rows={4}
                inputProps={{ maxLength }}
                sx={{ background: "rgba(255,255,255,0.8)" }}
              />
              <FormHelperText>
                Máximo permitido de información{" "}
                {`${values.description.length} / ${maxLength}`}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
              <CalendarMonthOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 30 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 18,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Tiempo de caducidad del link de pago
              </span>
            </Grid>
            {/* Campo de fecha de inicio */}
            <Grid item xs={6} md={6}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Inicio:
              </b>
              <TextField
                fullWidth
                value={dateStart ? format(dateStart, "dd/MM/yyyy") : ""}
                onClick={handleOpenStartCalendar}
                margin="dense"
                size="small"
                placeholder="Seleccionar fecha"
                InputProps={{
                  readOnly: true,
                }}
              />
              <Popover
                open={Boolean(anchorElStart)}
                anchorEl={anchorElStart}
                onClose={handleCloseStartCalendar}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Calendar
                    date={dateStart}
                    onChange={handleDateStartChange}
                    locale={es}
                    color={blackColor}
                    minDate={new Date()}
                  />
                </Box>
              </Popover>
            </Grid>

            {/* Campo de fecha de fin */}
            <Grid item xs={6} md={6}>
              <b
                className={classes.cardTitleBlack}
                style={{ fontSize: 14, fontWeight: 500 }}
              >
                Fin:
              </b>
              <TextField
                fullWidth
                value={dateEnd ? format(dateEnd, "dd/MM/yyyy") : ""}
                onClick={handleOpenEndCalendar}
                margin="dense"
                size="small"
                placeholder="Seleccionar fecha"
                InputProps={{
                  readOnly: true,
                }}
                disabled={!dateStart} // Deshabilitar hasta que se seleccione fecha inicio
              />
              <Popover
                open={Boolean(anchorElEnd)}
                anchorEl={anchorElEnd}
                onClose={handleCloseEndCalendar}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Calendar
                    date={dateEnd}
                    onChange={handleDateEndChange}
                    locale={es}
                    color={blackColor}
                    minDate={dateStart ? addDays(dateStart, 1) : new Date()}
                  />
                </Box>
              </Popover>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
              <AttachMoneyOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 30 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 18,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Monto a cobrar
              </span>
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor }}
                >
                  Aplica IVA:
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radioIva}
                  onChange={handleRadioIva}
                >
                  <FormControlLabel
                    value="0"
                    control={<Radio />}
                    label={`IVA ${parseFloat(UserAuth.iva)}%`}
                    sx={{ color: blackColor }}
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label={`IVA ${parseFloat(UserAuth.ivaHoliday)}%`}
                    sx={{ color: blackColor }}
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="OTRO"
                    sx={{ color: blackColor }}
                  />
                  <FormControlLabel
                    value="3"
                    control={<Radio />}
                    label="NO APLICA"
                    sx={{ color: blackColor }}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            {radioIva === "2" && (
              <Grid item xs={12} sm={12}>
                <TextField
                  name="otherIva"
                  value={values.otherIva}
                  onChange={(event) => {
                    handleChange("otherIva", event.target.value);
                  }}
                  fullWidth
                  required
                  label="Agregar otro IVA"
                  margin="dense"
                  autoComplete="off"
                  size="small"
                  sx={{ width: 200 }}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={12}>
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ color: blackColor }}
              >
                Total:
              </FormLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <b className={classes.cardTitleBlack} style={{ fontSize: 16 }}>
                Subtotal $:
              </b>
              <NumericFormat
                customInput={TextField}
                name="subtotal"
                value={values.subtotal}
                error={values.errorSubtotal}
                onValueChange={(vals) => handleChangeSubtotal(vals.value)}
                allowNegative={false}
                decimalSeparator=","
                thousandSeparator="." // opcional, para consistencia
                decimalScale={2} // opcional, limita a 2 decimales
                inputProps={{ style: { textAlign: "center" } }}
                fullWidth
                autoComplete="off"
                variant="outlined"
                margin="dense"
                size="small"
                placeholder="0"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <b className={classes.cardTitleBlack} style={{ fontSize: 16 }}>
                Iva $:
              </b>
              <center>
                <Box
                  sx={{
                    p: "8px 10px",
                    border: "1px solid #ccc",
                    background: "#F6F6F6",
                    mt: 1,
                    borderRadius: 1,
                  }}
                >
                  {values.ivaSubtotal}
                </Box>
              </center>
            </Grid>
            <Grid item xs={12} sm={4}>
              <b className={classes.cardTitleBlack} style={{ fontSize: 16 }}>
                Total $:
              </b>
              <center>
                <Box
                  sx={{
                    p: "8px 10px",
                    border: "1px solid rgb(30, 70, 32)",
                    background: "rgb(237, 247, 237)",
                    mt: 1,
                    borderRadius: 1,
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "rgb(30, 70, 32)",
                  }}
                >
                  {values.total}
                </Box>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
          <ButtonStyle0 onClick={submitForm}>Crear link</ButtonStyle0>
        </DialogActions>
      </Dialog>
      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity={alert.errorAlert === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {alert.mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      )}
      <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* DIALOG SUCCESS*/}
      <Dialog
        fullWidth
        maxWidth="xs"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={openSuccess}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          {" "}
          <Grid
            container
            spacing={2}
            className={classes.containerProfile}
            sx={{ mb: 3 }}
          >
            <Grid item xs={12} sm={12}>
              <center>
                <img src={successImg} alt="success" style={{ width: 150 }} />
                <br></br>
                <b
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 16, fontWeight: 500, marginTop: 5 }}
                >
                  Enlace creado exitosamente
                </b>
                <Alert severity="info">
                  Puedes copiar y pegar a donde desee o abrir el link de pago
                </Alert>
              </center>
            </Grid>
            <Grid item xs={12} sm={6} sx={{ my: 3 }}>
              <center>
                <CopyToClipboard
                  text={`${urlWeb}payment/${values.slugFinal}`}
                  onCopy={handleCopy}
                >
                  <ButtonTableGrid2
                    startIcon={<Link />}
                    style={{
                      margin: "12px 0 1px 0",
                      width: "100%",
                      fontSize: 14,
                      padding: 10,
                    }}
                  >
                    Copiar link
                  </ButtonTableGrid2>
                </CopyToClipboard>
              </center>
            </Grid>
            <Grid item xs={12} sm={6} sx={{ my: 3 }}>
              <center>
                <ButtonTableGrid2
                  startIcon={<OpenInNewOutlined />}
                  style={{
                    margin: "12px 0 1px 0",
                    width: "100%",
                    fontSize: 14,
                    background: "green",
                    padding: 10,
                    color: "#fff",
                  }}
                  onClick={() =>
                    window.open(
                      `${urlWeb}payment/${values.slugFinal}`,
                      "_blank",
                    )
                  }
                >
                  Abrir link
                </ButtonTableGrid2>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialogSuccess()}>Cerrar</ButtonExit>
        </DialogActions>
        <Snackbar
          open={openSnackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity="success"
            variant="filled"
          >
            {openSnackbar.mensage}
          </Alert>
        </Snackbar>
      </Dialog>
    </Fragment>
  );
}
